import { render, staticRenderFns } from "./page-6.vue?vue&type=template&id=60c5daa7&scoped=true&"
import script from "./page-6.vue?vue&type=script&lang=js&"
export * from "./page-6.vue?vue&type=script&lang=js&"
import style0 from "./page-6.vue?vue&type=style&index=0&id=60c5daa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c5daa7",
  null
  
)

export default component.exports